export default {
  path: '/property',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'spaceAssets',
      name: 'spaceAssets',
      component: () => import('@/pages/property/spaceAssets/index.vue'),
      meta: {
        keepAlive: true,
        title: '空间资产管理',
      },
    },
    {
      path: 'spaceAudit',
      name: 'spaceAudit',
      component: () => import('@/pages/property/spaceAudit/index.vue'),
      meta: {
        keepAlive: true,
        title: '空间审核',
      },
    },
    {
      path: 'spaceAuditDetail',
      name: 'spaceAuditDetail',
      component: () => import('@/pages/property/spaceAudit/spaceAuditDetail.vue'),
      meta: {
        keepAlive: true,
        title: '审核详情',
      },
    },
    {
      path: 'changeSpace',
      name: 'changeSpace',
      component: () => import('@/pages/property/changeSpace/index.vue'),
      meta: {
        keepAlive: true,
        title: '空间变更',
      },
    },
    {
      path: 'meterRegistration',
      name: 'meterRegistration',
      component: () =>
        import('@/pages/property/energyCibsynption/components/meterRegistration/index.vue'),
      meta: {
        keepAlive: true,
        title: '抄表登记',
      },
    },
    {
      path: 'repairsManagement',
      name: 'repairsManagement',
      component: () => import('@/pages/property/repairsManagement/index.vue'),
      meta: {
        keepAlive: true,
        title: '报修管理',
      },
    },
    {
      path: 'repairBillDetail',
      name: 'repairBillDetail',
      component: () => import('@/pages/property/repairsManagement/add.vue'),
      meta: {
        keepAlive: true,
        title: '报修单详情',
      },
    },
    {
      path: 'addRepairBill',
      name: 'addRepairBill',
      component: () => import('@/pages/property/repairsManagement/add.vue'),
      meta: {
        keepAlive: true,
        title: '新增报修单',
      },
    },
    {
      path: 'editRepairBill',
      name: 'editRepairBill',
      component: () => import('@/pages/property/repairsManagement/add.vue'),
      meta: {
        keepAlive: true,
        title: '编辑报修单',
      },
    },
    {
      path: 'auditRepair',
      name: 'auditRepair',
      component: () => import('@/pages/property/repairsManagement/add.vue'),
      meta: {
        keepAlive: true,
        title: '审核报修单',
      },
    },
    {
      path: 'workorderManagement',
      name: 'workorderManagement',
      component: () => import('@/pages/property/workorderManagement/index.vue'),
      meta: {
        keepAlive: true,
        title: '工单管理',
      },
    },
    {
      path: 'workorderDetail',
      name: 'WorkorderDetail',
      component: () => import('@/pages/property/workorderManagement/WorkorderDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '工单详情',
      },
    },
    {
      path: 'workorderComplete',
      name: 'WorkorderComplete',
      component: () => import('@/pages/property/workorderManagement/WorkorderComplete/index.vue'),
      meta: {
        keepAlive: true,
        title: '工单完工',
      },
    },
    {
      path: 'workorderCheck',
      name: 'WorkorderCheck',
      component: () => import('@/pages/property/workorderManagement/WorkorderCheck/index.vue'),
      meta: {
        keepAlive: true,
        title: '工单验收',
      },
    },
    {
      path: 'addWorkorder',
      name: 'AddWorkorder',
      component: () => import('@/pages/property/workorderManagement/AddWorkorder/index.vue'),
      meta: {
        keepAlive: true,
        title: '新增派工单',
      },
    },
    {
      path: 'editWorkorder',
      name: 'editWorkorder',
      component: () => import('@/pages/property/workorderManagement/AddWorkorder/index.vue'),
      meta: {
        keepAlive: true,
        title: '编辑派工单',
      },
    },
    {
      path: 'announcement',
      name: 'announcement',
      component: () => import('@/pages/property/announcement/announcementList/index.vue'),
      meta: {
        keepAlive: true,
        title: '通知公告',
      },
    },
    {
      path: 'announcementDetail',
      name: 'announcementDetail',
      component: () => import('@/pages/property/announcement/announcementDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '通知公告详情',
      },
    },
    {
      path: 'announcementCreate',
      name: 'announcementCreate',
      component: () => import('@/pages/property/announcement/announcementDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '通知公告新增',
      },
    },
    {
      path: 'announcementEdit',
      name: 'announcementEdit',
      component: () => import('@/pages/property/announcement/announcementDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '通知公告编辑',
      },
    },
    {
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/pages/property/feedback/feedbackList/index.vue'),
      meta: {
        keepAlive: true,
        title: '意见反馈',
      },
    },
    {
      path: 'feedbackCreate',
      name: 'feedbackCreate',
      component: () => import('@/pages/property/feedback/feedbackDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '意见反馈新增',
      },
    },
    {
      path: 'feedbackDetail',
      name: 'feedbackDetail',
      component: () => import('@/pages/property/feedback/feedbackDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '意见反馈详情',
      },
    },
    {
      path: 'feedbackEdit',
      name: 'feedbackEdit',
      component: () => import('@/pages/property/feedback/feedbackDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '意见反馈编辑',
      },
    },
    {
      path: 'feedbackhandle',
      name: 'feedbackhandle',
      component: () => import('@/pages/property/feedback/feedbackDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '意见反馈处理',
      },
    },
    {
      path: 'leaseContract',
      name: 'leaseContractManage',
      component: () => import('@/pages/property/leaseContract/index.vue'),
      meta: {
        keepAlive: true,
        title: '租赁合同管理',
      },
    },
    {
      path: 'addLeaseContract',
      name: 'addLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '新建租赁合同',
      },
    },
    {
      path: 'editLeaseContract',
      name: 'editLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '编辑租赁合同',
      },
    },
    {
      path: 'detailLeaseContract',
      name: 'detailLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '租赁合同详情',
      },
    },
    {
      path: 'auditLeaseContract',
      name: 'auditLeaseContract',
      component: () => import('@/pages/property/leaseContract/auditLeaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '审核租赁合同',
      },
    },
    {
      path: 'renewalLeaseContract',
      name: 'renewalLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '续签租赁合同',
      },
    },
    {
      path: 'changeInfoLeaseContract',
      name: 'changeInfoLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '变更合同信息',
      },
    },
    {
      path: 'changeSubjectLeaseContract',
      name: 'changeSubjectLeaseContract',
      component: () => import('@/pages/property/leaseContract/leaseContractPage.vue'),
      meta: {
        keepAlive: true,
        title: '变更合同主体',
      },
    },
  ],
};
